<template>
	<div class="container">
		<div style="position: absolute;width: 100%;z-index: -1;">
			<img src="../../assets/image/login/register_top.jpg" style="width: 100%;height: 90px;" alt="">
		</div>
		<login-header :info="webInfo"></login-header>
		<div class="register">
			<div class="box">
				<div class="item">
					<img src="../../assets/image/login/register1.png" />
					<div class="title">用电客户</div>
					<div class='content-a'>
						用电客户可以在平台上租赁用电服务，发电车、临时用电、共享电工、蓄电池、应急保电等服务。
					</div>
					<div class="button" @click="toForm(1)">
						注册
					</div>
				</div>
				<div class="item">
					<img src="../../assets/image/login/register2.png" />
					<div class="title">资源厂商</div>
					<div class='content-a'>
						您可以在平台上出租用电设备，提供用电方案，出租发电车等服务。
					</div>
					<div class="button" @click="toForm(2)">
						注册
					</div>
				</div>
				<div class="item">
					<img src="../../assets/image/login/register3.png" />
					<div class="title">共享电工</div>
					<div class='content-a'>
						我们是一站式服务平台，在用户购买用电设备会需要电工服务，我们会根据您的资质推送需求订单。
					</div>
					<div class="button" @click="toForm(3)">
						注册
					</div>
				</div>
			</div>
			<div class="index">
				<router-link to="/"><i class="el-icon-arrow-left"></i>返回登录</router-link>
			</div>
		</div>
		<div style="width: 785px;margin: 25px auto;text-align: center;color: #3f3f3f;">
			<div style="margin-top: 20px;font-size: 16px;">
				冀icp备2020029693号 冀公司安备1301990200540号
			</div>
			<div style="margin-top: 10px;font-size: 16px;">
				建议使用分辨率124X768以上
			</div>
		</div>
		<!-- <div class="footer">
			备案信息: {{webInfo.websiteNumber}}
		</div> -->
	</div>
</template>

<script>
	// import loginHeader from '../../components/loginHeader/index.vue'
	// import user from "../../components/register/user.vue"
	// import manufacturer from "../../components/register/manufacturer.vue"
	import { webInfoApi } from '../../http/api/user.js'
	//类型：厂商-0，用户-1，电工-2.
	export default {
		// components: {
		// 	user,
		// 	manufacturer,
		// 	loginHeader
		// },
		data() {
			return {
				webInfo: {}
			}
		},
		created() {
			this.getWebInfo()
		},
		methods: {
			getWebInfo() {
				webInfoApi().then(res => {
					this.webInfo = res
				})
			},
			toForm(type) {
				this.$router.push({
					path: '/registerDetails',
					query: {
						value: type
					}
				})
			},



		}
	}
</script>

<style scoped lang="less" scoped>
	.container {
		.register {
			margin: 0 auto;
			margin-top:70px ;
			width: 50%;
			height: 530px;
			.box {
				display: flex;
				justify-content: space-between;

				.item {
					padding: 10px 20px;
					margin: 20px;
					width: 400px;
					height: 372px;
					border-radius: 10px;
					border: 1px solid #EDEDED;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;

					img {
						width: 120px;
						height: 120px;
						margin-top: 29px;
						margin-bottom: 5px;
					}

					.title {
						text-align: center;
						font-size: 16px;
					}

					.content-a {
						font-size: 14px;
						margin-top: 26px;
						color: #7A7A7A;
					}

					.button {
						width: 120px;
						height: 40px;
						display: flex;
						align-items: center;
						justify-content: center;
						bottom: 32px;
						border-radius: 6px;
						font-size: 16px;
						color: #FF8A59;
						border: 1px solid #FF8A59;


						&:hover {
							cursor: pointer;
							color: white;
							background-color: #FF8A59;
						}
					}
				}
			}

			.index {
				display: flex;
				justify-content: center;
				margin-top: 40px;
				font-size: 14px;
				color: #9B9B9B;

				&:hover {
					cursor: pointer;
				}
			}
		}

		.footer {
			width: 100%;
			bottom: 30px;
			display: flex;
			justify-content: center;
			font-size: 14px;
			color: #ADADAD;
			position: fixed;
		}


	}
</style>
